import React from 'react';
import { useParams } from 'react-router-dom';
import ThemePlayer from '../components/ThemePlayer/ThemePlayer';
import { ScoreProvider } from '../context/ScoreProvider';

export default function ThemePage() {
  const { themeId } = useParams();

  return (
    <ScoreProvider key={themeId}>
      <ThemePlayer />
    </ScoreProvider>
  );
}
